export const DEFAULT_LAYOUT_BOTTOM_PADDING_VALUE = 2;
